module Meevo.Plugins.ImageGalleryCategory {
  "use strict";

  /**
  * Main Section of ImageGalleryCategory 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ImageGalleryCategory> {
    /**
    * Base class override which defines what a DEFAULT model looks like.
    */
    //public missingField: any = -1;
    public timeoutService: angular.ITimeoutService;

    createSectionModelInstance(postAdd:(data:any)=>any): void {
        this.dataService.getTemplate(this.baseEndpoint).then((data) => {
          this.model = data;
        });
    }

    //beforeSetFocusOnField() {
    //  //var that = this;

    //  //this.timeoutService(() => that.setFocusOnField(that.missingField));
    //}

    //setFocusOnField(field: any) {
     
    //}
  }
}